import React from "react";
export default ({ className, onClick, disabled = false, color = null }) => (
  <svg
    style={{ width: "1.5rem", height: "1.5rem" }}
    viewBox="0 0 17 20"
    className={`${className || ""} ${disabled ? "disabled" : ""}`}
    onClick={disabled ? null : onClick}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6027 8.05395C14.9107 8.82843 14.9107 10.7214 13.6027 11.4959L3.01915 17.7623C1.68594 18.5517 0.00018692 17.5907 0.00018692 16.0414V3.50847C0.00018692 1.95909 1.68594 0.998124 3.01915 1.78751L13.6027 8.05395Z"
      fill={color ? color : disabled ? "#4D4D4D" : "#fff"}
    />
  </svg>
);
